<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="申请人姓名" prop="nickname" >
        {{form.nickname}}
      </a-form-model-item>
      <a-form-model-item label="企业名称" prop="companyName" >
        {{form.companyName}}
      </a-form-model-item>
      <a-form-model-item label="当前岗位" prop="workName" >
        {{form.workName}}
      </a-form-model-item>
      <a-form-model-item label="入职日期 " prop="entryDate" >
        {{form.entryDate}}
      </a-form-model-item>
      <a-form-model-item label="员工单价 " prop="unitPrice" >
        {{form.unitPrice}}
      </a-form-model-item>
      <a-form-model-item label="薪资预支金额 " prop="money" >
        {{form.money}}
      </a-form-model-item>
      <a-form-model-item label="图片" prop="imgUrls" >
        <div v-if="form.imgUrls" style="display: flex;flex-wrap: wrap;width: 175px">
          <img
            v-if="item"
            v-viewer
            style="width: 80px;height: 80px;margin-right: 5px;margin-bottom: 5px"
            :src="item"
            :key="index"
            v-for="(item,index) in form.imgUrls.split(',')"/>
        </div>
        <div v-else>
          无反馈图片
        </div>
      </a-form-model-item>
      <a-form-model-item label="审核反馈图片" prop="checkImgs" >
        <div v-if="form.checkImgs" style="display: flex;flex-wrap: wrap;width: 175px">
          <img
            v-if="item"
            v-viewer
            style="width: 80px;height: 80px;margin-right: 5px;margin-bottom: 5px"
            :src="item"
            :key="index"
            v-for="(item,index) in form.checkImgs.split(',')"/>
        </div>
        <div v-else>
          无图片
        </div>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入" type="textarea" disabled allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
<!--          <a-button type="primary" :loading="submitLoading" @click="submitForm">-->
<!--            保存-->
<!--          </a-button>-->
          <a-button type="dashed" @click="cancel">
            关闭
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSalaryAdvance, addSalaryAdvance, updateSalaryAdvance } from '@/api/user/salaryAdvance'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        nickname: null,
        companyName: null,
        workName: null,
        entryDate: null,
        userId: null,
        money: null,
        imgUrls: '',
        unitPrice: null,
        status: 0,
        checkImgs: null,
        cateName: null,
        createTime: null,
        remark: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        cateName: [
          { required: true, message: '分类名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        nickname: null,
        companyName: null,
        workName: null,
        entryDate: null,
        userId: null,
        money: null,
        imgUrls: '',
        unitPrice: null,
        status: 0,
        checkImgs: null,
        cateName: null,
        createTime: null,
        remark: null
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSalaryAdvance({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '查看'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateSalaryAdvance(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSalaryAdvance(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
